"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noteList = void 0;
exports.noteList = [
    {
        note_id: "1",
        patient_mrn: "123",
        note_content: "test note",
        encounter_uid: "123456",
        coder_username: "superadmin@codametrix.com",
        coder_firstname: "super",
        coder_lastname: "admin",
        coder_fullName: "super admin",
        created_date: "2023-05-31 06:36:56 UTC",
        modified_date: "2023-05-31 06:36:56 UTC"
    },
    {
        note_id: "1",
        patient_mrn: "123",
        note_content: "test note2",
        encounter_uid: "123456",
        coder_username: "superadmin@codametrix.com",
        coder_firstname: "super",
        coder_lastname: "admin",
        coder_fullName: "super admin",
        created_date: "2023-05-31 06:36:56 UTC",
        modified_date: "2023-05-31 06:36:56 UTC"
    }
];
//# sourceMappingURL=coder-notes.js.map